import React from 'react';
import HelpMeDecideDDIA from 'components/help-me-decide/13/HelpMeDecideDDIA';
import { ProductLineId } from '@insurancemenu/imenu-components-lib/dist/types/ProductLineId';
import HelpMeDecideDDWI from 'components/help-me-decide/123/HelpMeDecideDDWI';
import HelpMeDecideAnthem from 'components/help-me-decide/anthem/HelpMeDecideAnthem';
import HelpMeDecideWahooHealth from 'components/help-me-decide/wahoo-health/HelpMeDecideWahooHealth';

export interface HelpMeDecideInfo {
  content: JSX.Element;
  /**
   * Dynamic names on 'help me decide' cards can incorporate filter names and browsing criteria.
   * These dynamic names allow you to set values for filters or criteria, remove or reset values, set names to cards
   * */
  dynamicNames: SponsorDynamicNames;
}

type HelpMeDecideINFO = {
  [key: string]: HelpMeDecideInfo;
};

type SponsorDynamicNames = {
  [key in ProductLineId]?: Record<number, string>;
};

export const HELP_ME_DECIDE_HELPER: HelpMeDecideINFO = Object.freeze({
  13: {
    content: <HelpMeDecideDDIA numberOfDentalCriteria={4} numberOfVisionCriteria={3} />,
    dynamicNames: {
      GroupDental: { 1: 'ACA', 2: 'Plan Network', 3: 'Annual Maximum Benefit', 4: 'Orthodontics' },
      GroupVision: { 1: 'Frame', 2: 'Eyeglass Lenses', 3: 'Fit and Follow Up' },
    },
  },
  123: {
    content: <HelpMeDecideDDWI numberOfDentalCriteria={3} />,
    dynamicNames: {
      GroupDental: { 1: 'groupSize', 2: 'ortho', 3: 'orthoCoverageLevel' },
    },
  },
  ANTHEM: {
    content: <HelpMeDecideAnthem numberOfMedicalCriteria={3} />,
    dynamicNames: {
      GroupMedical: { 1: 'insuranceType', 2: 'metallicLevel', 3: 'compatibility' },
    },
  },
  MI_PLANNERS: {
    content: <HelpMeDecideWahooHealth numberOfMedicalCriteria={4} />,
    dynamicNames: {
      GroupMedical: { 1: 'insuranceType', 2: 'metallicLevel', 3: 'carrier', 4: 'deductible' },
    },
  },
});

export const INITIAL_DDWI_BC: Record<string, string> = {
  groupSize: '10-24',
  ortho: 'true',
  orthoCoverageLevel: 'adult_child',
};

export const INITIAL_WAHOO_HEALTH_BC: Record<string, string> = {
  insuranceType_FILTER: 'PPO',
  metallicLevel_FILTER: 'Gold',
  fundingType: 'Fully-insured',
  compatibility_FILTER: 'Traditional',
};

export const INITIAL_ANTHEM_BC: Record<string, string> = {
  insuranceType_FILTER: 'PPO',
  metallicLevel_FILTER: 'Gold',
  compatibility_FILTER: 'Traditional',
};
